import { ArticleItemTitleLink } from '#components/Article/Items/ArticleItemTitleLink';
import { BoardSectionItemLink } from '#components/Board/Section/SectionItemLink';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import type { FeedTeaser } from '#domains/resolver/board-section-data';

import { BoardSectionItemFeedItemTeaser } from './BoardSectionFeedItem';
import styles from './BoardSectionItemShortnews.module.scss';

type Props = {
	shortNews: FeedTeaser[];
};

export function BoardSectionItemShortnews({ shortNews }: Props) {
	const environment = useEnvironment();
	const radioUrl = `${environment.endpoints.ENDPOINT_RADIO}/br24?autoplay` as `${string}:${string}`;

	const mappedShortnewsItems = shortNews.map((teaser, index) => {
		if (teaser.type === 'empty') {
			return null;
		}

		return <BoardSectionItemFeedItemTeaser key={teaser.title || `${teaser.rowId}-${index}`} teaser={teaser} />;
	});

	return (
		<section className={styles.wrapper}>
			<header className={styles.header}>
				<ArticleItemTitleLink headingClassName="heading1" as="h2" path="/meldung">
					BR24 Meldungen
				</ArticleItemTitleLink>
			</header>

			<section className={styles.body}>
				{shortNews.length > 0 ? mappedShortnewsItems : <h3>Derzeit sind keine Nachrichten verfügbar.</h3>}
			</section>

			<footer className={styles.footer}>
				<ul className={styles.list}>
					<BoardSectionItemLink href="/meldung">Mehr</BoardSectionItemLink>

					<BoardSectionItemLink href={radioUrl} target="_blank">
						BR24 hören
					</BoardSectionItemLink>
				</ul>
			</footer>
		</section>
	);
}
